// src/components/AppIcon.jsx
import React from "react";
import * as LucideIcons from "lucide-react";

// SAFARI-GÜVENLİ FALLBACK ICON (asla çökmez)
const FallbackIcon = LucideIcons.HelpCircle || (() => <span>?</span>);

export default function Icon({
  name,
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  className = "",
  ...props
}) {
  // Icons always stored as keys of LucideIcons object
  const IconComponent =
    (name && LucideIcons[name]) ||
    // SAFARI fallback (undefined olduğunda crash olmaz)
    FallbackIcon;

  try {
    return (
      <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
      />
    );
  } catch (e) {
    // son savunma hattı — hiçbir zaman boş render etmez
    return (
      <FallbackIcon
        size={size}
        color="gray"
        strokeWidth={strokeWidth}
        className={className}
        {...props}
      />
    );
  }
}
